import React from "react";
import PropTypes from "prop-types";
import { ListGroup, ListGroupItem } from "reactstrap";

const ListView = ({ items, children }) => {
  return (
    <ListGroup flush>
      {items.map((item, index) => (
        <ListGroupItem className="px-0" key={item.id || index}>
          {typeof children === "function" && children(item)}
        </ListGroupItem>
      ))}
    </ListGroup>
  );
};

ListView.propTypes = {
  items: PropTypes.array.isRequired
};

export default ListView;
